import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { ContractStatusEntity } from '../../../entities/mdqx/contract-status.entity';
import { ContractStatusActions, ContractStatusActionTypes } from '../../actions/mdqx/contract-status.actions';

export interface ContractStatusState extends EntityState<ContractStatusEntity> {
    fetched: boolean;
}

export const CONTRACTSTATUS_KEY = 'contractStatus';

const adapter = createEntityAdapter<ContractStatusEntity>({
    selectId: contractStatus => contractStatus.Id,
});

const initialState: ContractStatusState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function contractStatusReducer(state = initialState, action: ContractStatusActions) {
    switch (action.type) {
        case ContractStatusActionTypes.GetContractStatusResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllContractStatus = selectAll;

export const selectContractStatusFetched = (state: ContractStatusState) => state.fetched;
